<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 11:33:43
 * @LastEditors: xiaokun
 * @LastEditTime: 2021-05-20 15:02:29
 * @Description: 审批表格 已审批 未审批
 -->
<template>
  <div class="examine-approve-table">
    <div
      class="examine-approve-table-wrapper"
    >
      <!-- 列表 -->
      <list-biz
        ref="listBiz"
        class="examine-approve-table-biz"
        :config="config"
        :data="data"
        :total="total"
        :page="params.page"
        @on-current-change="handleOnCurrentChange"
      >
        <ds-search
          slot="search"
          :form-schema="formSchema"
          @on-search-click="handleOnSearchClick"
          @on-reset-click="handleOnResetClick"
          @change-ids="getDepartmentIds"
        />
      </list-biz>
    </div>
  </div>
</template>
<script>
import { unExamineList } from './un-examine-table-components/index.js'
import { alreadyExamineList } from './already-examine-table-components/index.js'
import deptMemberSelectBiz from '@components/dept-member-select-biz'
import dateTimePicker from './search-components/date-time-picker'
import taskSelect from './search-components/link-task'
export default {
  name: 'ExamineApproveTable',
  // components: { searchLine },
  props: {
    curContent: {
      type: String,
      default: 'unExamine'
    },
    // paperId
    paperId: {
      type: String,
      default: ''
    },
    // 是否为 试卷列表跳转进来的审批列表  学习任务跳来的审批列表 不展示关联任务筛选
    isPaperExamineApprove: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 表单配置数据
      config: {
        selectAll: false,
        // 列表模式
        mode: 'table',
        name: 'ExamineApproveTable',
        // 列表配置
        list: {},
        paperId: ''
      },
      formSchema: {
        // 公司部门选择
        department: {
          type: 'Object',
          value: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          defaultValue: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          width: '200',
          placeholder: '请选择部门、成员',
          ui: {
            widget: deptMemberSelectBiz, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 日期选择器
        dateTime: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '100',
          ui: {
            widget: dateTimePicker, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 任务列表
        taskIds: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '180',
          placeholder: '请选择任务',
          ui: {
            widget: taskSelect, // 组件名
            widgetConfig: {
              data: { paperId: '' }
            } // 组件配置
          }
        }
      },
      // 未审批
      formSchemaUnExamineList: {
        // 公司部门选择
        department: {
          type: 'Object',
          value: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          defaultValue: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          width: '200',
          placeholder: '请选择部门、成员',
          ui: {
            widget: deptMemberSelectBiz, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 日期选择器
        dateTime: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '100',
          ui: {
            widget: dateTimePicker, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 任务列表
        taskIds: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '180',
          placeholder: '请选择任务',
          ui: {
            widget: taskSelect, // 组件名
            widgetConfig: {
              data: { paperId: '' }
            } // 组件配置
          }
        }
      },
      // 已审批
      formSchemaExamineList: {
        // 公司部门选择
        department: {
          type: 'Object',
          value: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          defaultValue: {
            // 部门列表
            dept: [],
            // 成员列表
            member: []
          },
          width: '200',
          placeholder: '请选择部门、成员',
          ui: {
            widget: deptMemberSelectBiz, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 日期选择器
        dateTime: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '100',
          ui: {
            widget: dateTimePicker, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        },
        // 是否通过
        pass: {
          type: 'number',
          value: '',
          defaultValue: '',
          label: '',
          width: '120',
          placeholder: '是否通过',
          ui: {
            widget: 'DsSearchSelect', // 组件名
            // 组件配置
            widgetConfig: {
              // 初始化数据
              data: [{
                value: 1,
                label: '通过'
              }, {
                value: 2,
                label: '未通过'
              }]
            }
          }
        },
        // 任务列表
        taskIds: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '180',
          placeholder: '请选择任务',
          ui: {
            widget: taskSelect, // 组件名
            widgetConfig: {
              data: { paperId: '' }
            } // 组件配置
          }
        }
      },

      // 表单数据
      data: [],
      // 查询参数
      // tags: [],
      params: {
        paperId: '',
        // 是否审批  1是2否
        isApproval: 2,
        page: 1,
        pageSize: 10,
        taskIds: [],
        startTime: '',
        endTime: '',
        departmentIds: [],
        userIds: [],
        // 是否通过 1是2否 默认0
        pass: 0
      },
      total: 1,
      setDepartmentIds: ''
    }
  },
  watch: {},
  created () {
    // 如果为 课程列表跳来 不展示任务相关筛选
    if (!this.isPaperExamineApprove) {
      delete this.formSchema['taskIds']
    }
    // 表头初始化配置，试卷-审批-未审批 或者 课程列表-未审批
    this.config.list = unExamineList()
    if (!this.isPaperExamineApprove) {
      this.config.list = unExamineList('learnTask')
    }
    // 获取数据 为 未审批
    this.paperPaperApprovalListPostParams()
  },
  mounted () {},
  methods: {
    // 获取部门 成员ids
    getDepartmentIds (val) {
      this.setDepartmentIds = val
    },
    // 切换父级组件时，请求 不同 数据
    changeCurContent (val) {
      this.data = []
      this.formSchema = {}
      if (val === 'unExamine') {
        // 未审批
        // 表头配置
        this.config.list = unExamineList()
        if (!this.isPaperExamineApprove) {
          this.config.list = unExamineList('learnTask')
        }
        // this.config.list = unExamineList
        // 搜索配置
        this.formSchema = this.formSchemaUnExamineList
        this.params.isApproval = 2
      } else {
        // 已审批
        // 表头配置
        this.config.list = alreadyExamineList()
        if (!this.isPaperExamineApprove) {
          this.config.list = alreadyExamineList('learnTask')
        }
        // this.config.list = alreadyExamineList
        this.formSchema = this.formSchemaExamineList
        this.params.isApproval = 1
      }
      // 如果为 课程列表跳来 不展示任务相关筛选
      if (!this.isPaperExamineApprove) {
        delete this.formSchema['taskIds']
      }
      // 获取表格数据
      this.paperPaperApprovalListPostParams()
    },
    // 搜索
    handleOnSearchClick (params) {
      let { memberId, deptId } = this.setDepartmentIds
      let { taskIds, pass, dateTime } = params
      this.params = {
        ...this.params,
        userIds: memberId || [],
        departmentIds: deptId || [],
        taskIds: taskIds || [this.$route.query.taskId],
        pass: pass || 0,
        startTime: dateTime ? dateTime[0] : '',
        endTime: dateTime ? dateTime[1] : ''
      }
      this.paperListPost()
    },
    // 重置
    handleOnResetClick (params) {
      this.formSchema.dateTime.value = []
      if (this.formSchema.taskIds) this.formSchema.taskIds.value = []
      if (this.formSchema.pass) {
        this.formSchema.pass.value = ''
      }
      let { paperId, isApproval } = this.params
      this.setDepartmentIds = ''
      this.params = {
        paperId: paperId,
        // 是否审批  1是2否
        isApproval: isApproval,
        page: 1,
        pageSize: 10,
        taskIds: [],
        startTime: '',
        endTime: '',
        departmentIds: [],
        userIds: [],
        // 是否通过 1是2否 默认0
        pass: 0
      }

      this.paperListPost()
    },
    // 接口请求参数
    paperPaperApprovalListPostParams () {
      this.config.paperId = this.params.paperId = this.$route.query.paperId || this.paperId
      // 展示相关任务时，将paperid传入任务输入框 进行数据请求
      if (this.isPaperExamineApprove) {
        this.formSchema.taskIds.ui.widgetConfig.data.paperId = this.config.paperId
      } else if (!this.isPaperExamineApprove) {
        this.params.taskIds = [this.$route.query.taskId]
      }
      // 默认请求 未审批
      this.paperListPost()
    },
    // 获取数据
    async paperListPost () {
      let params = { ...this.params }
      let res = await MBASVCAPIS.PaperApi.paperPaperApprovalListPost(params)
      if (res.success) {
        let { data, total } = res.data
        this.data = data
        this.total = total
      } else {
      }
      this.isLoading = false
    },
    // 分页change事件
    handleOnCurrentChange (page) {
      this.params.page = page
      this.paperPaperApprovalListPostParams()
    }
  }
}
</script>
<style lang='scss' scoped>
.examine-approve-table {
  height: 0;
  flex: 1;
  overflow: hidden;

  .examine-approve-table-wrapper {
    height: 100%;
  }
}
</style>
